import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";

import SecurityProtection from "./Elements/SecurityProtection";
import ScrollToTop from "./Elements/ScrollUp";

import SiteHeader from "./Elements/SiteHeader";
import SiteFooter from "./Elements/SiteFooter";
import Home from "./Pages/Home";
import YourPractitioner from "./Pages/YourPractitioner";
import Services from "./Pages/Services";
import Testimonials from "./Pages/Testimonials";
import ContactUs from "./Pages/ContactUs";
import FAQs from "./Pages/FAQs";

import ClientForms from "./Pages/ClientForms";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import Disclaimer from "./Pages/Disclaimer";
import NotFound from "./Pages/NotFound";

const App = () => (
  <div>
    <BrowserRouter>
      <SecurityProtection />
      <ScrollToTop />
      <SiteHeader />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/your-practitioner" element={<YourPractitioner />} />
        <Route path="/services" element={<Services />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/faqs" element={<FAQs />} />
        <Route path="/client-forms" element={<ClientForms />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <SiteFooter />
    </BrowserRouter>
  </div>
);

export default App;
